function updatePercentageBar() {
  // Fetch values from the elements
  if (!document.getElementById("number-of-results") && !document.getElementById("total-number-of-results")) {
    return;
  }
  const numberOfResults = parseInt(
    document.getElementById("number-of-results").innerText,
    10
  );
  const totalNumberOfResults = parseInt(
    document.getElementById("total-number-of-results").innerText,
    10
  );

  // Check if total number of results is not zero to avoid division by zero
  if (totalNumberOfResults === 0) {
    return; // No need to calculate if the total is zero
  }

  // Calculate the percentage
  const percentage = (numberOfResults / totalNumberOfResults) * 100;

  // Update the width of the showing-persentage div
  const percentageBar = document.querySelector(".showing-persentage");
  percentageBar.style.width = percentage + "%";
}

// Run the function to update the percentage bar
updatePercentageBar();

function extractElementFromHTML(htmlString, tagName) {
  // Create a temporary container element
  var tempContainer = document.createElement("div");
  tempContainer.innerHTML = htmlString;

  // Find the element by tag name
  var element = tempContainer.querySelector(tagName);

  // Return the element or null if not found
  return element;
}

// Yotpo mounts the star ratings on collection cards when its loader resolves,
// which only happens once per page load. Cards injected by "Show more" and
// "Load previous" are DOM that Yotpo has never seen, so its widgets are left
// unmounted and those cards show no stars. Re-run the initialisation after
// injecting. The loader can still be in flight (it resolves several seconds
// after DOMContentLoaded), so retry briefly instead of giving up on a miss.
function initYotpoForNewCards(attempt) {
  const tries = attempt || 0;
  if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
    window.yotpoWidgetsContainer.initWidgets(false);
    return;
  }
  if (tries < 40) {
    setTimeout(function () { initYotpoForNewCards(tries + 1); }, 250);
  }
}

// "Skip to products" link at the top of the filter sidebar: move focus straight
// to the first product's thumbnail link (its first tab stop). Delegated because
// the sidebar/grid are re-rendered by filtering.
document.addEventListener('click', function (event) {
  const link = event.target.closest('[data-skip-to-products]');
  if (!link) return;
  const grid = document.getElementById('product-grid');
  if (!grid) return;
  event.preventDefault();
  const firstCard = Array.from(grid.querySelectorAll('.card__inner')).find(function (card) {
    return card.getClientRects().length > 0;
  });
  if (firstCard) {
    firstCard.focus();
  } else {
    // Empty grid: fall back to the container so focus still leaves the filters.
    grid.setAttribute('tabindex', '-1');
    grid.focus();
  }
});

// Last visible, tabbable element inside the grid items preceding `item`
// (walking back past items with nothing focusable, e.g. hidden ones).
function lastFocusableBefore(item) {
  const selector = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]';
  for (let el = item.previousElementSibling; el; el = el.previousElementSibling) {
    const focusables = Array.from(el.querySelectorAll(selector)).filter(function (node) {
      return node.tabIndex >= 0 && node.getClientRects().length > 0;
    });
    if (focusables.length) return focusables[focusables.length - 1];
  }
  return null;
}

async function loadMore(event, mode) {
  try {
    event.preventDefault();
    const linkSearchParams = new URLSearchParams(event.target.href.split('?')[1]);
    const pageNum = linkSearchParams.get('page');
    let url = event.target.href;
    let headersList = {
      Accept: "*/*",
      "User-Agent": "Thunder Client (https://www.thunderclient.com)",
    };

    let response = await fetch(`${url}`, {
      method: "GET",
      headers: headersList,
    });
    let data = await response.text();
    const existing_elem = document.querySelector(".load-more-content-show");
    const renderElem = extractElementFromHTML(data, ".load-more-content-show");
    if(mode === 'prev'){
      const existingLoadPrev = document.querySelector(".load-previous");
      const renderLoadPrev = extractElementFromHTML(data,".load-previous");
      existing_elem.insertAdjacentHTML('afterbegin',renderElem.innerHTML);
      if(renderLoadPrev){
        existingLoadPrev.replaceWith(renderLoadPrev);
      } else {
        let newDiv = document.createElement("div");
        newDiv.className = "load-previous";
        existingLoadPrev.replaceWith(newDiv);
      }
      // If page 1 loaded, inline banner is now present - enable solo item hiding
      if (parseInt(pageNum) === 1) {
        const productGrid = document.getElementById('product-grid');
        if (productGrid) {
          productGrid.classList.add('has-inline-banner');
          // Add portrait class for mobile hiding if banner type is portrait
          if (productGrid.dataset.inlineBannerType === 'portrait') {
            productGrid.classList.add('banner-type-portrait');
          }
        }
      }
    } else {
      const existing_load_button = document.querySelector(".pagination-component");
      const renderLoadMore = extractElementFromHTML(data,".pagination-component");

      // Decide which card to focus AFTER injecting:
      // - When an inline banner is present, the CSS hides the last "solo" card
      //   (.has-inline-banner:not(.all-products-loaded) > .grid__item:nth-last-child(1))
      //   to avoid an orphan row. Appending the next page makes that card
      //   visible again, so it's the first newly-visible card -> focus it.
      // - Otherwise focus the first card from the fetched markup.
      let focusCard = null;
      if (
        existing_elem.classList.contains('has-inline-banner') &&
        !existing_elem.classList.contains('all-products-loaded')
      ) {
        const hiddenSolo = existing_elem.lastElementChild;
        if (hiddenSolo && hiddenSolo.matches('.grid__item:not(.inline-banner-item)')) {
          focusCard = hiddenSolo;
        }
      }
      // First product card in the fetched markup (kept as a real node reference).
      const newNodes = Array.from(renderElem.childNodes);
      const firstNewProduct = newNodes.find(function (node) {
        return node.nodeType === 1 && node.matches('.grid__item:not(.inline-banner-item)');
      });
      newNodes.forEach(function (node) { existing_elem.appendChild(node); });

      // The "Show more" button is replaced below, which would drop focus to
      // the top of the page. Park focus on the last focusable element before
      // the new results instead, so the next Tab (or screen reader swipe)
      // lands on the first new product. Keyboard users still see a ring there
      // (programmatic focus inherits :focus-visible from the keyboard-focused
      // button); mouse/touch users get no ring. Cleared on blur.
      const cardToFocus = focusCard || firstNewProduct;
      const parkTarget = cardToFocus && lastFocusableBefore(cardToFocus);
      if (parkTarget) {
        if (event.detail !== 0) parkTarget.classList.add('is-silent-focus');
        parkTarget.focus({ preventScroll: true });
        parkTarget.addEventListener('blur', function onBlur() {
          parkTarget.classList.remove('is-silent-focus');
          parkTarget.removeEventListener('blur', onBlur);
        });
      }

      if (renderLoadMore) {
        existing_load_button.replaceWith(renderLoadMore);
        updatePercentageBar();
      } else {
        let newDiv = document.createElement("div");
        newDiv.className = "pagination-component";
        existing_load_button.replaceWith(newDiv);
        // All products loaded - show any hidden solo items
        document.getElementById('product-grid')?.classList.add('all-products-loaded');
      }
      //update page param in url
      const pageUrl = new URL(window.location.href);
      pageUrl.searchParams.set('page', parseInt(pageNum));   
      window.history.pushState({path:pageUrl.href}, '', pageUrl.href);
    }

    // Mount Yotpo star ratings on the cards just injected above.
    initYotpoForNewCards();
  } catch (err) {
    // console.log(err);
  }
}


// filters hide show .....
function desktopMenuShowHide() {
  console.clear()
  try {
    const mediaQuery = window.matchMedia('(min-width: 650px)');
    if (mediaQuery.matches) {
      const filterDiv = document.querySelector('.custom-style-filters-part')
      const upArrow = document.querySelector('.up-arrow')
      const downArrow = document.querySelector('.down-arrow')
      const ShowingTextElem = document.querySelector('#filter-menu-text')

      // Collapsed filters are only clipped to 0 width, so make them inert or
      // Tab would still walk through every (invisible) filter. The sidebar's
      // focus-ring/scrollbar padding and negative margins are cleared too, or
      // a sliver of the filters would still show at 0 width.
      if (filterDiv.style.width !== '0px') {
        filterDiv.style.width = '0px';
        filterDiv.style.overflow = 'hidden';
        filterDiv.style.padding = '0px';
        filterDiv.style.margin = '0px';
        filterDiv.inert = true;
        filterDiv.parentNode.style.gap = "0px";
        upArrow.style.display = 'none'
        downArrow.style.display = 'block'
        ShowingTextElem.innerText = 'Show Filters'
      } else {
        filterDiv.style.width = '';
        filterDiv.parentNode.style.gap = "47px";
        filterDiv.style.overflow = '';
        filterDiv.style.padding = '';
        filterDiv.style.margin = '';
        filterDiv.inert = false;
        upArrow.style.display = 'block'
        downArrow.style.display = 'none'
        ShowingTextElem.innerText = 'Hide Filters'
      }
    }
  } catch (error) {

  }
}